import { render, staticRenderFns } from "./boxAndGoodsInfo.vue?vue&type=template&id=72b816e3&scoped=true&"
import script from "./boxAndGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./boxAndGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./boxAndGoodsInfo.vue?vue&type=style&index=0&id=72b816e3&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b816e3",
  null
  
)

export default component.exports